import { render, staticRenderFns } from "./SelectStudentsStatus.vue?vue&type=template&id=79c16a20"
import script from "./SelectStudentsStatus.vue?vue&type=script&lang=js"
export * from "./SelectStudentsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports